<form *ngIf="formGroup" (ngSubmit)="applyForm()">
  <div class="form-row" *ngIf="isShowPoaForm">
    <div class="col-12" id="control-poaForm">
      <div class="mt-2">
        <app-control-wrapper [control]="poaFormControl" [errors]="errors">
          <document-upload-desktop
            control-wrapper
            [id]="'company-poa-upload-form'"
            [attachmentName]="'DOCUMENT_TYPE.POWER_OF_ATTORNEY'"
            [attachmentHint]="'COMPANY.BOND_PURCHASE_PLEASE_UPLOAD_POA'"
            [uploadedDocument]="poaFormControl.value"
            [canUploadDocuments]="true"
            [canRemoveDocuments]="false"
            [isLoading]="isLoadingCompanyPoa"
            [isRequired]="true"
            [isStretched]="true"
            (upload)="uploadPoa($event)"
            (stateUpdate)="updateDocumentState($event)"
          ></document-upload-desktop>
        </app-control-wrapper>
      </div>
    </div>
  </div>
  <div class="form-row mb-2">
    <div class="col-12 col-sm-6 label">{{ "FORM_LABEL.FULL_COMPANY_NAME" | translate }}</div>
    <div class="col-12 col-sm-6 value" id="control-companyName">{{ formGroup.get(["continuousBondDetails", "companyName"]).value }}</div>
  </div>
  <div class="form-row mb-2">
    <div class="col-12 col-sm-6 label">{{ "LABELS.BUSINESS_TYPE" | translate }}</div>
    <div class="col-12 col-sm-6 value" id="control-businessType">
      {{ "BUSINESS_TYPE." + businessTypeLabel | translate }}
    </div>
  </div>
  <div class="form-row mb-2">
    <div class="col-12 col-sm-6 label">{{ "FORM_LABEL.PHYSICAL_ADDRESS" | translate }}</div>
    <div class="col-12 col-sm-6 value" id="control-address">{{ formGroup.get(["continuousBondDetails", "address"]).value }}</div>
  </div>
  <div class="form-row mb-2">
    <div class="col-12 col-sm-6 label">{{ "FORM_LABEL.FEDERAL_TAX_ID_OR_IMPORTER_NUMBER" | translate }}</div>
    <div class="col-12 col-sm-6 value" id="control-importerNumber">
      {{ formGroup.get(["continuousBondDetails", "importerNumber"]).value }}
    </div>
  </div>
  <div class="form-row">
    <div class="col-12 d-flex justify-content-end">
      <button type="button" class="btn btn-link" [routerLink]="['/companies', 'account-settings', 'company-view', company.id]">
        {{ "BUTTON.UPDATE_COMPANY" | translate }}
      </button>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12" id="control-commodities">
      <app-control-wrapper [control]="formGroup.get(['continuousBondDetails', 'commodities'])" [errors]="errors">
        <label for="address" control-label>
          {{ "FORM_LABEL.COMMODITIES_BEING_IMPORTED" | translate }}
        </label>
        <input
          type="text"
          [formControl]="formGroup.get(['continuousBondDetails', 'commodities'])"
          class="form-control"
          id="commodities"
          name="commodities"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          control-wrapper
        />
      </app-control-wrapper>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12" id="control-mainCountryOfOriginCode">
      <auto-select
        [label]="'FORM_LABEL.COUNTRY_OF_ORIGIN'"
        [bindLabel]="['code', 'description']"
        [bindValue]="'code'"
        [change]="searchCountry()"
        [initializeItems]="initialCountry"
        [errors]="errors"
        [fc]="formGroup.get(['continuousBondDetails', 'mainCountryOfOriginCode'])"
        id="mainCountryOfOriginCode"
      ></auto-select>
    </div>
  </div>
  <div class="form-row" id="control-estimatedImportValue">
    <div class="col-12">
      <app-control-wrapper [control]="formGroup.get(['continuousBondDetails', 'estimatedImportValue'])" [errors]="errors">
        <label for="estimatedImportValue" control-label>
          {{ "LABELS.ANNUAL_ESTIMATED_VALUE_OF_IMPORTS" | translate }}
        </label>
        <input
          type="text"
          [formControl]="formGroup.get(['continuousBondDetails', 'estimatedImportValue'])"
          class="form-control"
          id="estimatedImportValue"
          name="estimatedImportValue"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          control-wrapper
        />
      </app-control-wrapper>
    </div>
  </div>
  <div class="form-row" id="control-estimatedDutyValue">
    <div class="col-12">
      <app-control-wrapper [control]="formGroup.get(['continuousBondDetails', 'estimatedDutyValue'])" [errors]="errors">
        <label for="estimatedDutyValue" control-label>
          {{ "LABELS.ANNUAL_ESTIMATED_DUTIES_VALUE" | translate }}
        </label>
        <input
          type="text"
          [formControl]="formGroup.get(['continuousBondDetails', 'estimatedDutyValue'])"
          class="form-control"
          id="estimatedDutyValue"
          name="estimatedDutyValue"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          control-wrapper
        />
      </app-control-wrapper>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12" id="control-stateOfIncorporationCode">
      <auto-select
        [label]="'LABELS.STATE_OF_INCORPORATION'"
        [bindLabel]="['code', 'description']"
        [bindValue]="'code'"
        [change]="searchState()"
        [initializeItems]="initialState"
        [errors]="errors"
        [fc]="formGroup.get(['continuousBondDetails', 'stateOfIncorporationCode'])"
        id="stateOfIncorporationCode"
      ></auto-select>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12" id="control-areCommoditiesSubjectToACD">
      <app-control-wrapper [control]="formGroup.get(['continuousBondDetails', 'areCommoditiesSubjectToACD'])" [errors]="errors">
        <label control-label>
          {{ "FORM_LABEL.ARE_COMMODITIES_SUBJECT_TO_ACD" | translate }}
        </label>
        <div class="d-flex" control-wrapper>
          <div class="mr-2">
            <app-radio-button
              [id]="'areCommoditiesSubjectToACD-yes'"
              [value]="true"
              [name]="'areCommoditiesSubjectToACD'"
              [control]="formGroup.get(['continuousBondDetails', 'areCommoditiesSubjectToACD'])"
              [label]="'LABELS.YES'"
            ></app-radio-button>
          </div>
          <div>
            <app-radio-button
              [id]="'areCommoditiesSubjectToACD-no'"
              [value]="false"
              [name]="'areCommoditiesSubjectToACD'"
              [control]="formGroup.get(['continuousBondDetails', 'areCommoditiesSubjectToACD'])"
              [label]="'LABELS.NO'"
            ></app-radio-button>
          </div>
        </div>
      </app-control-wrapper>
    </div>
  </div>
  <div class="form-row" id="control-notes">
    <div class="col-12">
      <app-control-wrapper [control]="formGroup.get(['continuousBondDetails', 'estimatedDutyValue'])" [errors]="errors">
        <label for="notes" control-label>
          {{ "LABELS.NOTES" | translate }}
        </label>
        <textarea
          [formControl]="formGroup.get(['continuousBondDetails', 'notes'])"
          class="form-control"
          id="notes"
          name="notes"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F{700}'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          [maxMaskLength]="700"
          control-wrapper
          [rows]="3"
        ></textarea>
      </app-control-wrapper>
    </div>
  </div>
  <div *ngIf="error" class="text-error">{{ error | translate }}</div>
  <div class="d-flex justify-content-center">
    <button type="submit" class="btn btn-primary">
      {{ (poaFormControl.invalid || formGroup.invalid ? "BUTTON.VALIDATE" : "BUTTON.SAVE") | translate }}
    </button>
  </div>
</form>
